import {Alert, Button, Space, Spin, Typography} from 'antd';
import type {SupportedProject} from '../../api/prdispatch';

interface Props {
    projects: SupportedProject[];
    loading: boolean;
    error: string | null;
    selectedProjectId: string | null;
    onSelect: (id: string) => void;
    disabled?: boolean;
}

export const ProjectStep = ({projects, loading, error, selectedProjectId, onSelect, disabled}: Props) => (
    <section>
        <Typography.Title level={5}>1. Project</Typography.Title>
        {loading && <Spin/>}
        {error && <Alert type='error' title='Failed to load projects' description={error}/>}
        {!loading && !error && (
            <Space wrap>
                {projects.map((p) => (
                    <Button
                        key={p.id}
                        type={selectedProjectId === p.id ? 'primary' : 'default'}
                        onClick={() => onSelect(p.id)}
                        disabled={disabled}
                    >
                        {p.displayName}
                    </Button>
                ))}
            </Space>
        )}
    </section>
);
